import { FileDownloadService } from "@topline/services/fileDownloadService";
import moment from "moment";
import { MarketDataProvider } from "../services/marketDataProvider";
import ng from "angular";
import { ForecastParametersProvider } from "../../Forecast/services/forecastParametersProvider";
import { ToasterService } from "@topline/services/toasterService";
import { ImsDataService } from "../../Forecast/services/initializeAndRefresh/imsDataService";
import { GridValueEditorService } from "../../Forecast/components/common/gridValueEditor/service/gridValueEditorService";
import { Gen } from "@topline/services/api";

class MarketValueComponentController {
    public marketId: string;
    public filters: Gen.MarketFilterDTO[];
    public showYears: boolean = true;
    public isCollapsedMarketValue: boolean = true;
    public config: $TSFixMe;
    public marketValue: $TSFixMe;
    public serverOperation: $TSFixMe;
    public yearlyMarketValueGridOptions: $TSFixMe;
    public monthlyMarketValueGridOptions: $TSFixMe;

    static $inject = [
        MarketDataProvider.componentName,
        ForecastParametersProvider.componentName,
        ImsDataService.componentName,
        GridValueEditorService.componentName,
        ToasterService.componentName,
        FileDownloadService.componentName,
        "$q",
        "$scope"
    ];

    constructor(
        private marketDataProvider: MarketDataProvider,
        private forecastParametersProvider: ForecastParametersProvider,
        private imsDataService: ImsDataService,
        private gridValueEditorService: GridValueEditorService,
        private toasterService: ToasterService,
        private fileDownloadService: FileDownloadService,
        private $q: ng.IQService,
        private $scope: ng.IScope
    ) {}

    $onInit() {
        this.serverOperation = this.getConfig().then(() => {
            this.$scope.$watch(
                () => this.filters,
                () => this.loadMarketValue(),
                true
            );
        });
    }

    downloadSkuReport() {
        const apiEndpoint = "/api/ims/market/value/skus/report";

        this.toasterService.showReportGenerateBusyIndicator(
            () =>
                this.fileDownloadService.downloadFilePost(apiEndpoint, "MarketSkus.xlsx", {
                    filters: this.filters,
                    startMonth: this.config.startDate,
                    endMonth: this.config.endDate
                }),
            "MARKET.SKUS_REPORT_GENERATING",
            "MARKET.SKUS_REPORT_GENERATED"
        );
    }

    private loadMarketValue() {
        return this.marketDataProvider
            .getMarketData(this.filters, this.config.startDate, this.config.endDate)
            .then((data: $TSFixMe) => {
                this.marketValue = data;
                this.populateDataToGridOptions();
            });
    }

    private getConfig() {
        return this.$q
            .all([this.forecastParametersProvider.getForecastDefaults(), this.imsDataService.getLatestData()])
            .then((results: $TSFixMe) => {
                const historicalDataLengthInYears = results[0].defaultHistoricalDataPeriod;
                const imsEndDate = results[1].dataTo;
                this.config = {
                    historicalDataLengthInYears,
                    imsEndDate,
                    imsImportDate: results[1].importDate,

                    startDate: moment
                        .utc(imsEndDate)
                        .startOf("year")
                        .add(-historicalDataLengthInYears, "years")
                        .toDate(),
                    endDate: imsEndDate
                };
            });
    }

    private populateDataToGridOptions() {
        if (!this.marketValue) return;

        this.yearlyMarketValueGridOptions = {
            gridName: "yearlyMarketValueGridOptions",
            header: _.range(this.config.startDate.getFullYear(), this.config.endDate.getFullYear() + 1),
            readOnly: true,
            valuesDecimalPlaces: 0,
            gridData: [
                {
                    header: "{{ 'QUANTITY' | translate}}",
                    values: this.marketValue.yearly.volume
                },
                {
                    header: "{{ 'VALUE' | translate}}",
                    values: this.marketValue.yearly.value
                }
            ]
        };

        this.monthlyMarketValueGridOptions = {
            gridName: "monthlyMarketValueGridOptions",
            header: this.gridValueEditorService.prepareHeaderData(this.config.startDate, this.config.endDate),
            readOnly: true,
            valuesDecimalPlaces: 0,
            gridData: [
                {
                    header: "{{ 'QUANTITY' | translate}}",
                    values: this.marketValue.monthly.volume
                },
                {
                    header: "{{ 'VALUE' | translate}}",
                    values: this.marketValue.monthly.value
                }
            ]
        };
    }
}

export class MarketValueComponent implements ng.IComponentOptions {
    static componentName = "marketValue";
    bindings = {
        marketId: "<",
        filters: "<"
    };
    controller = MarketValueComponentController;
    template = require("./marketValueComponent.html");
}

angular.module("topline.modules").component(MarketValueComponent.componentName, new MarketValueComponent());
